<template>
  <section>
    <dialog-component
      :isShow="isShow"
      :dialogData="dialogData"
      isError
      @cancel="isShow=false"
      @next="handleNext">
      <div class="email-dialog">
        <p class="tip">
          When do you want to cancel this customer’s membership?
        </p>
        <div class="email-content">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <el-form-item
              ref="cancel_type"
              :rules="rules.select"
              prop="cancel_type">
              <v-radio-group
                v-model="formData.cancel_type"
                :list="list"
                block

              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </dialog-component>

  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'email-dialog',
  components:{

  },
  mixins: [MixinOptions, MixinRules],
  props:{
    value: {
      type: Boolean,
      default: false
    },
    expiredTime:{
      type:String,
      default: ''
    },
    autoRenew: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      isShow:true,
      linkSent:false,
      formData:{
        cancel_type:''
      }

    }
  },
  computed:{
    list(){
      let tody = new Date()
      tody = this.showHKDate(tody)
      
      let cancelList = [
        {
          name:`Immediately ${tody}`,
          id:1,
        },
        {
          name:`End of current period ${this.expiredTime}`,
          id:2,
        }
      ]
      let list = cancelList.filter(item => {
        return this.autoRenew? item : item.id != 2
      })
      return list
    },
    dialogData(){
      return{
        title:'Cancel Membership ',
        buttonRightText:'Cancel Subscription',
        cancelText:'Don’t Cancel'
      }
    },
    editDialogData(){
      return{
        title:'Link Sent',
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(status) {
        if (status !== this.isShow) {
          this.isShow = status
        }
      }
    },
    isShow: {
      immediate: true,
      handler(status) {
        if(status !== this.value) {
          this.$emit('input', status)
        }
      }
    }
  },

  methods:{
    handleShow(){
      this.isShow = true
    },
    handleNext(){
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          this.$emit('continue',this.formData.cancel_type)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.email-dialog{
  .tip{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    word-wrap:break-word;
  }
  .email-content {
    /*margin-left: 15px;*/
    margin-top: 20px;
    ::v-deep ul {
      li {
        &:nth-child(1) {
          .name {
            color: #22863A!important;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
